import React from 'react';

import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { CommunityWorkflowDocuments } from './CommunityWorkflowDocuments';
import { CommunityWorkflowMetrics } from './CommunityWorkflowMetrics';

const useStyles = makeStyles()(theme => ({
  communitySummaryTabContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 40,
  },
  metrics: {
    marginBottom: theme.spacing(2),
  },
  note: {
    background: theme.appColors.selectedBackgroundNav,
    borderRadius: 10,
    boxSizing: 'border-box',
    display: 'flex',
    padding: theme.spacing(2),
    width: '100%',
  },
}));

interface CommunitySummaryTabContentProps {
  workflowId: UUID;
}

export function CommunitySummaryTabContent({
  workflowId,
}: CommunitySummaryTabContentProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.communitySummaryTabContent}>
      <Note />
      <CommunityWorkflowMetrics className={classes.metrics} workflowId={workflowId} />
      <CommunityWorkflowDocuments workflowId={workflowId} />
    </div>
  );
}

function Note(): JSX.Element {
  const { classes } = useStyles();
  return (
    <div className={classes.note}>
      <Typography variant="body2">
        This workflow is published to the Aline Community. Once imported you can customize it with
        your own information.
      </Typography>
    </div>
  );
}
